import { ELightGalleryType } from '@quesmed/types/models';
import { BsImage } from 'react-icons/bs';
import { FiUploadCloud } from 'react-icons/fi';
import { cn } from 'tailwind-variants';
import { useAsset } from '@/store';
import type { IQChoice } from '../question';

type Props = {
  choice?: IQChoice['choices'][number];
  type: ELightGalleryType;
  title?: string;
};
export const AssetUploader = ({ choice, type, title }: Props) => {
  const setAssetModal = useAsset.use.setAssetModal();
  const setAssetEditor = useAsset.use.setAssetEditor();
  const assetMapping = useAsset.use.assetMapping();
  const assetKey = choice ? assetMapping[`${type}-${choice.label}`] : assetMapping[`${type}`];

  const handleClick = () => {
    if (choice) {
      setAssetModal(
        true,
        `Choice:${choice.label.toUpperCase()}:${ELightGalleryType[type]}`,
        type,
        choice.label,
      );
    } else {
      setAssetModal(true, title ?? '', type);
    }
  };

  const handleUpload = () => {
    if (choice) {
      setAssetEditor({ key: type, choiceLabel: choice.label });
    } else {
      setAssetEditor({ key: type });
    }
  };
  return (
    <>
      {assetKey && (
        <button
          onClick={handleClick}
          type='button'
          className={cn(
            'flex gap-1 cursor-pointer bg-background p-1.5 border border-default-300 rounded-md items-center justify-center',
          )}
        >
          <span className='text-xs pt-0.5 leading-none font-mono'>{assetKey}</span>
          <BsImage className='size-3' />
        </button>
      )}
      <button
        onClick={handleUpload}
        type='button'
        className={cn(
          'flex cursor-pointer bg-warning-50 p-1.5 border border-warning-200 rounded-md items-center justify-center',
        )}
      >
        <FiUploadCloud className='size-3 text-warning-500' />
      </button>
    </>
  );
};
